import { useEffect } from 'react';

import { getTeamIdFromUrl } from '../../services/team/teamSwitcherHelper';

export default function Pendo() {
  const teamId = getTeamIdFromUrl();

  useEffect(() => {
    if (teamId && window.env.REACT_APP_PENDO_CLIENT_KEY) {
      pendo.initialize({
        account: {
          id: teamId,
        },
      });
    }
  }, [teamId]);

  return null;
}
